import { call, put, takeEvery, all, fork } from "redux-saga/effects";

// Crypto Redux States
import {
  GET_GLOBAL_THRESHOLDS,
  POST_GLOBAL_THRESHOLD,
} from "./actionTypes";

//Include Both Helper File with needed methods

import {
  getGlobalThresholdsSuccess,
  getGlobalThresholdsFail,
  postGlobalThresholdFail,
} from "./actions";

import {
  getGlobalThresholds,
  postAddGlobalThreshold
} from "../../helpers/fakebackend_helper";

function* onGetGlobalThresholds() {
  try {
    const response = yield call(getGlobalThresholds);
    yield put(getGlobalThresholdsSuccess(response));
  } catch (error) {
    yield put(postGlobalThresholdFail(error));
  }
}


function* globalThresholdSaga() {
  yield takeEvery(GET_GLOBAL_THRESHOLDS, onGetGlobalThresholds);
}

export default globalThresholdSaga;
